export default __webpack_public_path__ + "09b19843615412c94a297ca7d930bea2.svg";